<template>
  <div class="inner">
    <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('コスト情報') }}</h2>
    <div class="mt-5" id="costInfoDrawing-parent">
      <div class="card">
        <div
          class="accordion card-header d-flex justify-content-between"
          id="costInfoDrawing-header"
          data-toggle="collapse"
          data-target="#costInfoDrawing"
          :aria-expanded="false"
          aria-controls="costInfoDrawing"
        >
          <h3 class="mb-0">{{ $t('コスト') }}</h3>
          <div class="accordion-toggle-btn">
            <b-button block id="costInfoDrawing-up">{{ $t('閉じる') }}</b-button>
            <b-button block id="costInfoDrawing-down">{{ $t('開く') }}</b-button>
          </div>
        </div>
        <div
          id="costInfoDrawing"
          class="collapse"
          aria-labelledby="costInfoDrawing-header"
          data-parent="#costInfoDrawing-parent"
        >
          <div class="card-body">
            <table class="table table-bordered">
              <tbody class="tbody">
                <tr>
                  <th class="table-active text-left w-10">
                    {{ $t('基準売単価') }}
                  </th>
                  <td class="w-15">
                    <template v-if="!this.isEmpty(product.salesPrice)">
                      {{ product.salesPrice | mixinCommaDisplay}}&nbsp;{{ $t('円') }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <th class="table-active text-left w-10">
                    <template v-if="product.type === 'ownbrand'">
                      {{ $t('基準製造原価') }}
                    </template>
                    <template v-else>
                      {{ $t('基準仕入単価') }}
                    </template>
                  </th>
                  <td class="w-15">
                    <template v-if="!this.isEmpty(product.purchasePrice)">
                      {{ product.purchasePrice | mixinCommaDisplay}}&nbsp;{{ $t('円') }}
                    </template>
                    <template v-else-if="totalCost">
                      {{ totalCost | mixinCommaDisplay}}&nbsp;{{ $t('円') }}
                    </template>
                    <template v-else>
                      -
                    </template>
                    <!-- <template v-if="product.type === 'ownbrand'">
                      -
                    </template>
                    <template v-else>
                    </template> -->
                  </td>
                  <th class="table-active text-left w-10">{{ $t('コスト備考') }}</th>
                  <td class="text-break w-40">
                    <template v-if="!this.isEmpty(product.priceNote)">
                      {{ product.priceNote }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3 mb-5">
      <button @click="costModalOpen()" type="button" class="btn btn-light create-btn">{{ $t('編集') }}</button>
    </div>
    <cost-modal
    ref="cost"
    @registered="registered()"
    @modalClose="modalClose()"
    :product="product"
    ></cost-modal>
  </div>
</template>

<script>
import costModal from './costModal'
export default {
  props: {
    product: {
      type: Object,
    },
    totalCost: {
      type: Number,
      default: 0,
    },
  },
  components: {
    costModal,
  },
  mounted() {
    const up = document.getElementById('costInfoDrawing-up')
    const down = document.getElementById('costInfoDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#costInfoDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('costInfoDrawing-up')
      const down = document.getElementById('costInfoDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#costInfoDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('costInfoDrawing-up')
      const down = document.getElementById('costInfoDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
  },
  methods: {
    costModalOpen() {
      this.$refs.cost.modalOpen(this.totalCost)
    },
    registered() {
      this.$emit('registered')
    },
    modalClose() {
      this.$emit('modalClose')
    },
  },
  computed: {
    _watchValue() {
      return [this.product, this.totalCost]
    },
  },
  watch: {
    '_watchValue': {
      handler: function(newVal) {
        if (!this.isEmpty(newVal[0].salesPrice) || !this.isEmpty(newVal[0].purchasePrice) || !this.isEmpty(newVal[0].priceNote) || newVal[1] !== 0) {
          $('#costInfoDrawing').collapse('show')
        } else {
          $('#costInfoDrawing').collapse('hide')
        }
      },
      deep: true,
    },
  },
}
</script>

<style>
</style>
